import {
  DeliveryDetailsWidget,
  getIncotermsInfo,
  INITIAL_ADDRESS_VALUES,
} from "@fero/components";
import { FormLabel, Grid, Stack } from "@mui/material";
import type { StorageLocationView } from "adl-gen/ferovinum/app/api";
import { OptionPicker } from "components/library/helpers/option-picker";
import type { FormikForm } from "components/types/formik-types";
import { useCallback } from "react";
import type { DeliveryFormValues } from "../organisation-repurchase-delivery-page-view";
import { useSelectedCustomerAddress } from "../useSelectedCustomerAddress";
import { OUT_OF_BOND_DELIVERY_INCOTERMS } from "./delivery-form";

const INCOTERMS = getIncotermsInfo(OUT_OF_BOND_DELIVERY_INCOTERMS);
export const CustomerDeliveryOption = ({
  form,
  storageLocation,
}: {
  form: FormikForm<DeliveryFormValues>;
  storageLocation: StorageLocationView;
}) => {
  const getDeliveryPointName = useCallback(
    () => form.values.customerAddress?.deliveryPointName,
    [form.values.customerAddress],
  );
  const {
    selectedCustomer,
    setSelectedCustomer,
    selectableCustomers,
    selectableCustomerAddresses,
  } = useSelectedCustomerAddress(getDeliveryPointName);

  return (
    <Grid container spacing={4}>
      {selectableCustomers && (
        <Grid item xs={12} lg={6} pr={{ xs: 0, lg: 2 }}>
          <Stack spacing={2}>
            <FormLabel component="legend">Customer</FormLabel>
            <OptionPicker
              value={selectedCustomer}
              options={selectableCustomers}
              disabled={selectableCustomers.length === 0}
              onValueChange={(value) => {
                form.setFieldValue("address", INITIAL_ADDRESS_VALUES);
                setSelectedCustomer(value ? value : null);
              }}
              textFieldProps={{
                label: "Select Customer",
              }}
            />
          </Stack>
        </Grid>
      )}
      <Grid item xs={12}>
        <DeliveryDetailsWidget
          form={form}
          formKey="customerAddress"
          savedDeliveryInfoList={selectableCustomerAddresses}
          storageLocationName={storageLocation.storageLocationName}
          deliveryCountries={storageLocation.deliveryCountries}
          deliveryInstructionConfig={storageLocation.deliveryInstructionConfig}
          incoterms={{
            values: INCOTERMS,
          }}
        />
      </Grid>
    </Grid>
  );
};
